module.exports = __webpack_public_path__ + "static/media/t5.04fab63a.jpg";